import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearchPlus, faBalanceScale, faMapMarkedAlt,
  faUsers, faHeart, faUser, faBeer, faKissWinkHeart, faUserTie, faHiking,
  faSun, faCloudSun, faSnowflake, faLeaf, faCloudShowersHeavy,
  faStar, faHome, faBed,
  faCarrot, faSeedling, faBreadSlice, faMapPin,
  faPlane, faTrain, faBus, faCar, faShip,
  faLandmark, faMountain, faMask, faUmbrellaBeach, faTree, faCocktail, faCamera, faShoppingBag
} from "@fortawesome/free-solid-svg-icons";

export const TRIP_PLAN_KEY = "romaya_trip_plan";
export const MAX_TRIP_DAYS = 16;
export const MIN_TRIP_DAYS = 2;
export const MAX_DESTINATIONS = 8;

export const defaultFormData = {
  startingLocation: "",
  startingLocationData: null,
  destination: "",
  destinationData: null,
  destinations: [],
  customNightsPerDestination: {},
  stops: [],
  startDate: "",
  endDate: "",
  themes: [],
  travelStyle: "",
  weather: [],
  accommodation: ["3 Star", "4 Star"],
  food: [],
  travelToDest: [],
  travelBetween: [],
  legPlans: {},
  rooms: [{ adults: 2, children: [] }],
  adults: 2,
  children: 0,
  infants: 0,
  budget: "",
  currency: "INR",
  preferences: "",
  mealPlan: "MAP",
  tripType: "",
  includeTransport: true,
};

export const THEMES = [
  { id: "historical", label: "Historical Sites", icon: <FontAwesomeIcon icon={faLandmark} className="text-gray-500" /> },
  { id: "adventure", label: "Adventure", icon: <FontAwesomeIcon icon={faMountain} className="text-amber-700" /> },
  { id: "culture", label: "Local Culture", icon: <FontAwesomeIcon icon={faMask} className="text-purple-500" /> },
  { id: "beaches", label: "Beaches", icon: <FontAwesomeIcon icon={faUmbrellaBeach} className="text-blue-400" /> },
  { id: "nature", label: "Nature & Wildlife", icon: <FontAwesomeIcon icon={faTree} className="text-green-500" /> },
  { id: "nightlife", label: "Nightlife", icon: <FontAwesomeIcon icon={faCocktail} className="text-pink-500" /> },
  { id: "instagram", label: "For the Gram", icon: <FontAwesomeIcon icon={faCamera} className="text-indigo-500" /> },
  { id: "shopping", label: "Shopping", icon: <FontAwesomeIcon icon={faShoppingBag} className="text-orange-500" /> },
];

export const TRAVEL_STYLE_OPTIONS = [
  { id: "deep", label: "Deep Dive (1-2 cities)", icon: <FontAwesomeIcon icon={faSearchPlus} className="text-teal-600" />, desc: "Explore fewer places in more detail" },
  { id: "balanced", label: "Balanced (mix)", icon: <FontAwesomeIcon icon={faBalanceScale} className="text-teal-600" />, desc: "Cover a good mix of cities" },
  { id: "explorer", label: "Explorer (max cities)", icon: <FontAwesomeIcon icon={faMapMarkedAlt} className="text-teal-600" />, desc: "See as many places as possible" },
];

export const MEAL_PLAN_OPTIONS = [
  { id: "EP", label: "EP — Room Only" },
  { id: "CP", label: "CP — Breakfast only" },
  { id: "MAP", label: "MAP — Breakfast + Dinner" },
  { id: "AP", label: "AP — Breakfast + Lunch + Dinner" },
];

export const TRIP_TYPE_OPTIONS = [
  { id: "Family", label: "Family", icon: <FontAwesomeIcon icon={faUsers} className="text-teal-600" /> },
  { id: "Couple", label: "Couple", icon: <FontAwesomeIcon icon={faHeart} className="text-pink-500" /> },
  { id: "Solo", label: "Solo", icon: <FontAwesomeIcon icon={faUser} className="text-teal-600" /> },
  { id: "Friends", label: "Friends", icon: <FontAwesomeIcon icon={faBeer} className="text-amber-500" /> },
  { id: "Honeymoon", label: "Honeymoon", icon: <FontAwesomeIcon icon={faKissWinkHeart} className="text-red-500" /> },
  { id: "Senior", label: "Senior", icon: <FontAwesomeIcon icon={faUserTie} className="text-teal-600" /> },
  { id: "Adventure", label: "Adventure", icon: <FontAwesomeIcon icon={faHiking} className="text-green-600" /> },
];

export const WEATHER_OPTIONS = [
  { id: "warm", label: "Warm and Sunny", icon: <FontAwesomeIcon icon={faSun} className="text-yellow-500" /> },
  { id: "cool", label: "Cool and Breezy", icon: <FontAwesomeIcon icon={faCloudSun} className="text-blue-400" /> },
  { id: "cold", label: "Cold and Snowy", icon: <FontAwesomeIcon icon={faSnowflake} className="text-blue-300" /> },
  { id: "mild", label: "Mild and Pleasant", icon: <FontAwesomeIcon icon={faLeaf} className="text-green-500" /> },
  { id: "rainy", label: "Rainy and Cozy", icon: <FontAwesomeIcon icon={faCloudShowersHeavy} className="text-gray-500" /> },
];

export const ACCOMMODATION_OPTIONS = [
  { id: "3 Star", label: "3 Star", icon: <div className="flex text-yellow-400"><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} className="ml-0.5" /><FontAwesomeIcon icon={faStar} className="ml-0.5" /></div> },
  { id: "4 Star", label: "4 Star", icon: <div className="flex text-yellow-400"><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} className="ml-0.5" /><FontAwesomeIcon icon={faStar} className="ml-0.5" /><FontAwesomeIcon icon={faStar} className="ml-0.5" /></div> },
  { id: "5 Star", label: "5 Star", icon: <div className="flex text-yellow-400"><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} className="ml-0.5" /><FontAwesomeIcon icon={faStar} className="mx-0.5" /><FontAwesomeIcon icon={faStar} /><FontAwesomeIcon icon={faStar} className="ml-0.5" /></div> },
  { id: "AirBnb", label: "AirBnb", icon: <FontAwesomeIcon icon={faHome} className="text-rose-500" /> },
  { id: "Homestay", label: "Homestay", icon: <FontAwesomeIcon icon={faBed} className="text-teal-600" /> },
];

export const FOOD_OPTIONS = [
  { id: "vegetarian", label: "Vegetarian", icon: <FontAwesomeIcon icon={faCarrot} className="text-orange-500" /> },
  { id: "vegan", label: "Vegan", icon: <FontAwesomeIcon icon={faSeedling} className="text-green-500" /> },
  { id: "glutenfree", label: "Gluten Free", icon: <FontAwesomeIcon icon={faBreadSlice} className="text-amber-600" /> },
  { id: "local", label: "Local Cuisine", icon: <FontAwesomeIcon icon={faMapPin} className="text-red-500" /> },
];

export const TRAVEL_TO_OPTIONS = [
  { id: "flights", label: "Flights", icon: <FontAwesomeIcon icon={faPlane} className="text-blue-500" /> },
  { id: "trains", label: "Trains", icon: <FontAwesomeIcon icon={faTrain} className="text-gray-600" /> },
  { id: "buses", label: "Buses", icon: <FontAwesomeIcon icon={faBus} className="text-teal-600" /> },
  { id: "road", label: "Road", icon: <FontAwesomeIcon icon={faCar} className="text-red-500" /> },
];

export const TRAVEL_BETWEEN_OPTIONS = [
  { id: "flights", label: "Flights", icon: <FontAwesomeIcon icon={faPlane} className="text-blue-500" /> },
  { id: "trains", label: "Trains", icon: <FontAwesomeIcon icon={faTrain} className="text-gray-600" /> },
  { id: "buses", label: "Buses", icon: <FontAwesomeIcon icon={faBus} className="text-teal-600" /> },
  { id: "road", label: "Road", icon: <FontAwesomeIcon icon={faCar} className="text-red-500" /> },
  { id: "ferry", label: "Ferry", icon: <FontAwesomeIcon icon={faShip} className="text-cyan-600" /> },
];

export const STEPS = [
  {
    number: 1,
    title: "Set the Course,\nOwn the Journey",
    subtitle: "Define your dream destination and chart the perfect path to make it a reality.",
  },
  {
    number: 2,
    title: "Craft Your\nComfort Zone",
    subtitle: "Customize your trip with the right balance of relaxation and adventure — make it truly yours.",
  },
  {
    number: 3,
    title: "Choose Your\nTransport",
    subtitle: "Pick the best transport options for each leg of your journey.",
  },
  {
    number: 4,
    title: "Plan Your\nBudget",
    subtitle: "Set your travel budget and number of travelers to get personalized recommendations.",
  },
  {
    number: 5,
    title: "Feasibility\nCheck",
    subtitle: "Reviewing your travel plan details.",
  },
];

